import { setCookie } from '../utils/cookies'

export default function () {
  const currentUrl = new URL(window.location.href)
  const cookieName = '_gpc_practice_id'

  if (!currentUrl.searchParams.has('pid')) {
    return
  }

  const practiceId = currentUrl.searchParams.get('pid')

  setCookie(cookieName, practiceId)
}
